import { GetComponentQuery, GetPageByRouteQuery } from "@eurodrive/apollo"
import { BlockRenderer } from "@eurodrive/ui"
import { getBreadCrumbs, transformProperties } from "@eurodrive/utils"
import { BranchDto } from "api"

type Props = {
  data: GetPageByRouteQuery
  locale: string
  branches: BranchDto[]
  brands: GetComponentQuery
  branchesUmbraco: GetComponentQuery
}

// Define the components mapping object based on the block types from the query
const components = {
  heroBannerItem: () => import("@eurodrive/ui/Banner"),
  LastSeenCarCarousel: () => import("@eurodrive/ui/PreviouslyViewed"),
  mapBlock: () => import("./Map"),
}

export default function Branches({
  data,
  locale,
  branches,
  brands,
  branchesUmbraco,
}: Props) {
  const parsedData = data?.page?.properties || []
  const { blocks } = transformProperties(parsedData)
  const breadCrumbs = getBreadCrumbs(data, locale)
  return (
    <>
      {blocks?.blocks?.map((block: any, index: number) => {
        let blockProps = {}
        if (block.blockType === "heroBannerItem") {
          blockProps = { breadCrumbs }
        }
        if (block.blockType === "mapBlock") {
          blockProps = { branches, branchesUmbraco }
        }
        if (block.blockType === "LastSeenCarCarousel") {
          blockProps = { brands }
        }
        return (
          <BlockRenderer
            key={index}
            blockType={block.blockType}
            blockData={block}
            components={components}
            locale={locale}
            props={blockProps}
          />
        )
      })}
    </>
  )
}
